import {rest} from 'msw'
const data = require('../data/field-settings.json')

export default [
  rest.get('/swc-api/nodes/:nodeId/downloads/', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json([])
    )
  })
]
